module.exports = __webpack_public_path__ + "static/media/about-us-image.a8ec2a67.png";